import gql from 'graphql-tag'

export const initAbcStatistics = gql`
query initAbcStatistics($params: StatisticsRequestParams!) {
  cashAssist {
    initAbcStatistics(params: $params)
  }
}
`

export const getStatisticsData = gql`
query getStatisticsData($requestId: ID!) {
	cashAssist {
		getStatisticsData(requestId: $requestId) {
			status
      progress
			hasNextPage
      data {
				...on StatisticsABC {
					shopName
					dateTime
					code
					name
					salesGroup
					group1
					group2
					group3
					total
					number
					weight
					creditCustomerTotal
					creditCustomer
					creditCustomerWeight
					order1
					order1Amount
					unsold
					unsoldAmount
					unsoldPercent
					deliver
					correction
					correctionAmount
					stock
					stockAmount
					oldStock
					difference
					differenceAmount
					productCount
					billAmount1
					billAmount2
					billAmount3
					billAmount4
					onlyThis
					firstSale
					lastSale
					inCafeNumber
					inCafeTotal
					promotionNumber
					promotionTotal
					breakfastNumber
					breakfastTotal
					discountNumber
					discountTotal
					g1Percent
					g1PercentT
					g1Abc
					productId
					gNumber
					grossProfit
					contributionMargin
				}
			}
    }
  }
}
`
